<template>
  <div class="homeImg">
    <el-carousel
      height="567px"
      :interval="3000"
      arrow="never"

    >
      <el-carousel-item v-for="item in imgList" :key="item.id">
        <img
          @mouseenter="handleMouseIn(item.id)"
          @mouseleave="handleMouseOut(item.id)"
          @click="handleImgClick(item.id)"
          :src="item.src"
          alt=""
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "HomeBanner",
  data() {
    return {
      imgList: [
        {
          id: 1,
          src: require("../../assets/images/homeimg/banner1.jpg"),
          details: null
        },
        {
          id: 2,
          src: this.$t("lang.imgUrl.homeBanner3"),
          details: ""
        },
        /*{
          id: 3,
          src: require("../../assets/images/homeimg/banner2.jpg"),
          details: null
        }*/
      ]
    };
  },
  methods: {
    handleImgClick(id) {
      if (id === 2) {
        this.$router.push("/BestMedicalCare");
      }
    },
    handleMouseIn(id) {
      if (id === 2) {
        this.$el.style.cursor = "pointer";
      }
    },
    handleMouseOut(id) {
      if (id === 2) {
        this.$el.style.cursor = "default";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.homeImg {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  /*height: 567px;*/
  overflow: hidden;
  img {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  .el-carousel {
    overflow: hidden;
  }
}
</style>
